import script from "./RecoveryCodes.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoveryCodes.vue?vue&type=script&setup=true&lang=js"

import "./RecoveryCodes.vue?vue&type=style&index=0&id=1a2b0446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a2b0446"]])

export default __exports__